// Collapse long option lists (rendered by the Globo swatch app) to two rows
// with a "+N more" toggle, so the buy buttons stay near the top of the page.
(() => {
  const ROWS = 2;

  const collapse = (list) => {
    if (list.dataset.seCollapsed) return;
    const items = [...list.children];
    if (items.length < 10) return;

    const rowTops = [...new Set(items.map((li) => li.offsetTop))].sort((a, b) => a - b);
    if (rowTops.length <= ROWS) return;

    const cutoff = rowTops[ROWS];
    const hidden = items.filter((li) => li.offsetTop >= cutoff).length;
    list.dataset.seCollapsed = 'true';
    list.style.setProperty('--se-collapsed-height', `${cutoff - rowTops[0]}px`);
    list.classList.add('se-options--collapsed');

    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'se-options-toggle link';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.textContent = `+ ${hidden} more`;
    toggle.addEventListener('click', () => {
      const expanded = list.classList.toggle('se-options--collapsed') === false;
      toggle.setAttribute('aria-expanded', String(expanded));
      toggle.textContent = expanded ? 'Show less' : `+ ${hidden} more`;
    });
    list.after(toggle);
  };

  const scan = () => document.querySelectorAll('.product .globo-swatch-list ul.value').forEach(collapse);

  const start = () => {
    scan();
    const root = document.querySelector('.product__info-container');
    if (root) new MutationObserver(scan).observe(root, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
